import {
  EventDetails,
  EventTicketSelect,
  EventTicketIdentity,
  EventCustomFields,
  EventSeating,
  EventPayment,
  EventPaymentResult,
  EventPaymentFrame,
  EventCheckoutFrame,
  EventMerchSelect,
  PackageSelect,
} from 'ui/event';

export const EventRoutes = {
  /*eventsHome: {
    component: EventsHome,
    path: '/event/home',
  },
  eventMap: {
    component: EventMap,
    path: '/event/map',
  },
  eventCreateDetails: {
    component: EventCreateDetails,
    path: '/event/create/details',
  },
  eventCreateOptions: {
    component: EventCreateOptions,
    path: '/event/create/options',
  },
  eventCreateFinancials: {
    component: EventCreateFinancials,
    path: '/event/create/financials',
  },
  eventCreateConfirm: {
    component: EventCreateConfirm,
    path: '/event/create/confirm',
  },
  eventCreateResult: {
    component: EventCreateResult,
    path: '/event/create/result',
  },*/
  eventDetails: {
    component: EventDetails,
    path: '/event/details/:id',
  },
  eventTicketSelect: {
    component: EventTicketSelect,
    path: '/event/ticket/select/:id',
  },
  eventTicketIdentity: {
    component: EventTicketIdentity,
    path: '/event/ticket/identity',
  },
  eventCustomFields: {
    component: EventCustomFields,
    path: '/event/custom-fields',
  },
  eventSeating: {
    component: EventSeating,
    path: '/event/seats',
  },
  eventPayment: {
    component: EventPayment,
    path: '/event/payment',
  },
  eventPaymentFrame: {
    component: EventPaymentFrame,
    path: '/event/payment-frame',
  },
  eventCheckoutFrame: {
    component: EventCheckoutFrame,
    path: '/event/payment-checkout',
  },
  eventPaymentResult: {
    component: EventPaymentResult,
    path: '/payment-result/:result',
  },
  eventMerchSelect: {
    component: EventMerchSelect,
    path: '/event/merch/select',
  },
  eventPackageSelect: {
    component: PackageSelect,
    path: '/event/package/select',
  },
};